<div class="outstanding-reports-container">
  <!-- Header Bar -->
  <div class="header-bar">
    <div class="header-title">Outstanding Reports</div>
    <div class="header-refresh">
      <lucide-icon name="refresh-cw" [size]="20"></lucide-icon>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="main-content">
    <!-- Left Section: Outstanding Reports -->
    <div class="section outstanding-reports-section">
      <div class="section-header">
        <div class="section-header-title">Outstanding Reports</div>
      </div>
      <div class="section-content">
        <div class="patient-list">
          @for (report of reportsToBeCompletedList; track report; let i = $index) {
            <div class="patient-item"
              [class.selected]="selectedCaseFinalReportId === report.CaseFinalReportID"
              (click)="onFinalReportSelect(report)">
              <div class="patient-info">
                <div class="patient-name">{{ report.PatientName }}</div>
                <div class="appointment-date">on {{ report.Appointment | date:'M/d/yy' }}</div>
              </div>
              <div class="folder-icon">
                <lucide-icon name="folder" [size]="20"></lucide-icon>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Middle Section: Manage Report -->
    <div class="section manage-report-section">
      <div class="section-header">
        <div class="section-header-title">Manage Report</div>
      </div>
      <div class="section-content">
        <!-- Patient Info Header -->
        <div class="patient-header">
          <div class="patient-icon">
            <lucide-icon name="user" [size]="20"></lucide-icon>
          </div>
          <div class="patient-details">
            <div class="patient-name">{{ selectedReport?.PatientName }}</div>
            <div class="tooth-info">Tooth: {{ selectedReport?.ToothInfo }}</div>
            <div class="exam-date">Initial Exam Date: {{ selectedReport?.ExamDate | date:'M/d/yy' }}</div>
          </div>
        </div>

        <!-- Report Fields -->
        <div class="report-fields">
          <!-- Case Status -->
          <div class="field-row">
            <div class="field-label">Case Status:</div>
            <div class="field-controls">
              <app-tdo-enum-select name="enumCaseStatus" [validValueItemId]="caseStatusId" (enumSelected)="onCaseStatusChange($event)"></app-tdo-enum-select>
              <div class="date-input">
                <span class="date-label">On:</span>
                <input
                  style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                  (focus)="onCaseStatusDateFocus($event)"
                  (blur)="onCaseStatusDateInputFinish($event.target.value)"
                  [value]="caseStatusDateFormatted"
                  autocomplete="off"
                  />
                </div>
              </div>
            </div>

            <!-- Referral Report Sent -->
            <div class="field-row">
              <div class="field-controls">
                <mat-checkbox [(ngModel)]="referralReportSent" (change)="onReferralReportSentChange($event)">Referral Report Sent</mat-checkbox>
                <div class="date-input">
                  <span class="date-label">On:</span>
                  <input
                    style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                    (focus)="onReferralReportDateFocus($event)"
                    (blur)="onReferralReportDateInputFinish($event.target.value)"
                    [value]="referralReportDateFormatted"
                    autocomplete="off"
                    />
                  </div>
                </div>
              </div>

              <!-- Claim Created/Sent if needed -->
              <div class="field-row">
                <div class="field-controls">
                  <mat-checkbox [(ngModel)]="claimCreatedSent" (change)="onClaimCreatedSentChange($event)">Claim Created/Sent if needed</mat-checkbox>
                  <div class="date-input">
                    <span class="date-label">On:</span>
                    <input
                      style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                      (focus)="onClaimDateFocus($event)"
                      (blur)="onClaimDateInputFinish($event.target.value)"
                      [value]="claimDateFormatted"
                      autocomplete="off"
                      />
                    </div>
                  </div>
                </div>

                <!-- Patient Has Insurance -->
                <div class="field-row">
                  <div class="field-controls">
                    <span class="insurance-text">Patient Has Insurance</span>
                    <div class="person-icon">
                      <lucide-icon name="user" [size]="20"></lucide-icon>
                    </div>
                  </div>
                </div>

                <!-- Diagnostic Report -->
                <div class="field-row">
                  <div class="field-controls">
                    <mat-checkbox [(ngModel)]="diagnosticReport" (change)="onDiagnosticReportChange($event)">Diagnostic Report</mat-checkbox>
                    <div class="date-input">
                      <span class="date-label">On:</span>
                      <input
                        style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                        (focus)="onDiagnosticReportDateFocus($event)"
                        (blur)="onDiagnosticReportDateInputFinish($event.target.value)"
                        [value]="diagnosticReportDateFormatted"
                        autocomplete="off"
                        />
                      </div>
                    </div>
                    <div class="radio-group">
                      <mat-radio-group [(ngModel)]="diagnosticReportSize" (change)="onDiagnosticReportSizeChange($event)">
                        <mat-radio-button value="small">Small</mat-radio-button>
                        <mat-radio-button value="large">Large</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>

                  <!-- Interim Report -->
                  <div class="field-row">
                    <div class="field-controls">
                      <mat-checkbox [(ngModel)]="interimReport" (change)="onInterimReportChange($event)">Interim Report</mat-checkbox>
                      <div class="date-input">
                        <span class="date-label">On:</span>
                        <input
                          style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                          (focus)="onInterimReportDateFocus($event)"
                          (blur)="onInterimReportDateInputFinish($event.target.value)"
                          [value]="interimReportDateFormatted"
                          autocomplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Referral Reports Sub-section -->
                    <div class="sub-section">
                      <div class="field-row">
                        <div class="field-controls">
                          <mat-checkbox [(ngModel)]="reportListSameAsFinal" (change)="onReportListSameAsFinalChange($event)">Report List same as in 'Final Report'</mat-checkbox>
                        </div>
                      </div>
                    </div>

                    <!-- Send Sub-section -->
                    <div class="sub-section">
                      <div class="field-row">
                        <div class="field-controls">
                          <div class="send-field">
                            <span class="send-label">To:</span>
                            <input class="send-input" [(ngModel)]="sendTo1" placeholder="" />
                            <div class="date-input">
                              <span class="date-label">On:</span>
                              <input
                                style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                                (focus)="onSendDate1Focus($event)"
                                (blur)="onSendDate1InputFinish($event.target.value)"
                                [value]="sendDate1Formatted"
                                autocomplete="off"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="field-row">
                          <div class="field-controls">
                            <div class="send-field">
                              <span class="send-label">To:</span>
                              <input class="send-input" [(ngModel)]="sendTo2" placeholder="" />
                              <div class="date-input">
                                <span class="date-label">On:</span>
                                <input
                                  style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                                  (focus)="onSendDate2Focus($event)"
                                  (blur)="onSendDate2InputFinish($event.target.value)"
                                  [value]="sendDate2Formatted"
                                  autocomplete="off"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Right Section: Actions -->
                  <div class="section actions-section">
                    <div class="section-header">
                      <div class="section-header-title">Actions</div>
                    </div>
                    <div class="section-content">
                      <div class="actions-content">
                        <div class="no-report-checkbox">
                          <mat-checkbox [(ngModel)]="noReportNeeded" (change)="onNoReportNeededChange($event)">No Report Needed</mat-checkbox>
                        </div>
                        <div class="action-buttons">
                          <button class="tdo-button tdo-blue" (click)="onOpenReferralReports()">Open Referral Report(s)</button>
                          <button class="tdo-button tdo-blue" (click)="onClaims()">Claims</button>
                          <button class="tdo-button tdo-blue" (click)="onAutoClaim()">Auto Claim</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
